import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class TestComponent implements OnInit {


  constructor(private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit() {
    this.addCustomScript();
  }

  addCustomScript() {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = `
    (async function() {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const btn = urlParams.get('btn');
            const env = urlParams.get('env');
            let apiDomain, appDomain;

            switch (env) {
                case 'qa':
                    apiDomain = "qa-api.txtbox.in";
                    appDomain = "https://qa-app.txtbox.in";
                    break;
                case 'stg':
                    apiDomain = "api.txtbox.in";
                    appDomain = "https://app.txtbox.in";
                    break;
                case 'us':
                    apiDomain = "api.sms-magic.com";
                    appDomain = "https://app.sms-magic.com";
                    break;
                case 'eu':
                    apiDomain = "eu.api.sms-magic.com";
                    appDomain = "https://eu.app.sms-magic.com";
                    break;
                case 'aus':
                    apiDomain = "aus-api.sms-magic.com";
                    appDomain = "https://aus-app.sms-magic.com";
                    break;
                case 'int':
                    apiDomain = "dev-api.txtbox.in";
                    appDomain = "https://dev-app.txtbox.in";
                    break;
                default:
                    return; // Exit if env is not recognized
            }

            let latitude = "";
            let longitude = "";
            const timeoutDuration = 3000;
            const dasDevUrl = "https://das-dev.deepalgorithms.io";

            async function fetchData() {
                const requestUrl = \`\${appDomain}/v1/conversive/button/run/\${btn}?latitude=\${latitude}&longitude=\${longitude}\`;
                try {
                    const response = await fetch(requestUrl);
                    const data = await response.json();
                    if (data.response.status === "success") {
                        const responseData = data.response.data;
                        if (document.getElementById(responseData.button_config.scriptLocation)) {
                            displayButton(responseData);
                        } else {
                            loadResources(responseData);
                        }
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }

            function loadResources(data) {
                const head = document.getElementsByTagName("head")[0];

                const loadCSS = (href) => {
                    return new Promise((resolve) => {
                        const link = document.createElement("link");
                        link.rel = "stylesheet";
                        link.type = "text/css";
                        link.href = href;
                        link.onload = resolve;
                        head.appendChild(link);
                    });
                };

                const loadScript = (src, id) => {
                    return new Promise((resolve) => {
                        const script = document.createElement("script");
                        script.type = "text/javascript";
                        script.id = id;
                        script.src = src;
                        script.onload = resolve;
                        head.appendChild(script);
                    });
                };

                Promise.all([
                    loadCSS(data.button_config.cssLocation),
                    loadCSS(data.chatbot_config.chatbotCSS),
                    loadScript(data.button_config.scriptLocation, data.button_config.scriptLocation)
                ]).then(() => {
                    displayButton(data);
                    return loadScript(data.chatbot_config.chatbotJS, data.chatbot_config.chatbotJS);
                }).then(() => {
                    loadChatBot(dasDevUrl, apiDomain, data);
                });
            }

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    latitude = position.coords.latitude;
                    longitude = position.coords.longitude;
                    fetchData();
                }, fetchData, { timeout: timeoutDuration });
            } else {
                fetchData();
            }

            setTimeout(fetchData, timeoutDuration);
        } catch (error) {
            console.error('Error in script execution:', error);
        }
    })();
    `;
    this.renderer.appendChild(this.el.nativeElement, script);
}
clearCookiesAndLocalStorage() {
  // Clear local storage
  localStorage.clear();

  // Clear cookies
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      location.reload();

  }
}
}
